export default __webpack_public_path__ + "static/media/description-bottom.eb93d173.png";